
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2.301","y":"2.07","width":"16","height":"16","rx":"2","fill":"#348EF6"}}),_c('path',{attrs:{"d":"M11.8 6.264h2.5M11.8 10.264h2.5M6.3 14.264h8","stroke":"#E0ECFC","stroke-width":"2","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"5.301","y":"5.264","width":"4","height":"6","rx":"1","fill":"#E0ECFC"}})])
          )
        }
      }
    